<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <date-format-select
        @changeDateFormatData="changeDateFormatData($event.dateFormatId)"
        :isMonthly="true"
      />
      <search-channel-select v-model="tableParams.channelId" />
      <search-channel-slot-select
        v-model="tableParams.slotId"
        :channel-id="tableParams.channelId"
      />
      <search-dsp-select v-model="tableParams.dspId" />
      <search-dsp-slot-select
        v-model="tableParams.dspSlotId"
        :dsp-id="tableParams.dspId"
      />
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        :hide="hides"
        style="padding-bottom: 10px"
      >
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        @sort-change="sortChange"
        :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          align="center"
          :prop="v.field"
          :sortable="
            v.field === 'timeHour' ||
            v.field === 'filterPercentage' ||
            v.field === 'interfaceTotal' ||
            v.field === 'numberFilters' ||
            v.field === 'reqTotal'
          "
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
        >
          <template v-slot="scope">
            <span>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60, 100, 200]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
  </div>
</template>

<script>
import DateFormatSelect from "@/components/DateFormatSelect";
import SearchChannelSelect from "@/components/SearchChannelSelect";
import SearchDspSlotSelect from "@/components/SearchDspSlotSelect";
import SearchDspSelect from "@/components/SearchDspSelect";
import SearchChannelSlotSelect from "@/components/SearchChannelSlotSelect";
import BaseDatePicker from "@/components/BaseDatePicker";
import TableColumn from "@/components/TableColumn";
import initTableMixin from "@/mixins/initTable";
import downExcelMixin from "@/mixins/downExcel";

export default {
  name: "secondhand",
  components: {
    DateFormatSelect,
    SearchChannelSelect,
    SearchDspSelect,
    SearchDspSlotSelect,
    SearchChannelSlotSelect,
    BaseDatePicker,
    TableColumn,
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        { field: "timeHour", title: "时间" },
        { field: "channelId", title: "渠道ID" },
        { field: "channelName", title: "渠道名称" },
        { field: "dspId", title: "预算Id" },
        { field: "dspSlotId", title: "预算广告位Id" },
        { field: "filterPercentage", title: "过滤百分比" },
        { field: "interfaceTotal", title: "接口调用总量" },
        { field: "numberFilters", title: "秒针过滤总数" },
        { field: "reqTotal", title: "请求总量" },
        { field: "secondHandId", title: "唯一Id" },
        { field: "slotId", title: "渠道广告位Id" },
        { field: "slotName", title: "渠道广告位名称" },
      ],
    };
  },
  mounted() {
    this.tableParams.showType = 1;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    beforeInit() {
      this.tableUrl = "/reportSecondhand/secondhand/list";
      return true;
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime;
      this.tableParams.endTime = date.endTime;
    },
    changeDateFormatData(dateFormatId) {
      if (dateFormatId === 1) {
        // 日
        this.tableParams.showType = 1;
      } else if (dateFormatId === 2) {
        // 时
        this.tableParams.showType = 0;
      } else if (dateFormatId === 3) {
        // 月
        this.tableParams.showType = 2;
      } else {
        // 正常
        this.tableParams.showType = 1;
      }
      this.toQuery();
    },
    sortChange(column) {
      this.tableParams.asc = "";
      this.tableParams.desc = "";
      if (column.order === "ascending") {
        this.tableParams.asc = column.prop;
      } else {
        this.tableParams.desc = column.prop;
      }
      this.init();
    },
  },
};
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;
  & > * {
    margin-right: 15px;
    margin-bottom: 10px;
    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;
  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}
::v-deep.el-table__placeholder {
  display: none;
}
::v-deep.el-table__expand-icon {
  width: auto !important;
}
// /deep/.el-table__footer-wrapper tbody td{
//   border-bottom: none;
//   .cell{
//   overflow: hidden;
//   text-overflow: ellipsis;
//   word-break:normal
//   }
// }
// /deep/.el-table__fixed-footer-wrapper tbody td{
//   border-bottom: none;
//   .cell{
//       word-break:normal;
//   }
// }
// /deep/.el-table__fixed-header-wrapper .cell{
//   width: 70px;
// }
// /deep/.el-table__body-wrapper {
//   order: 0;
// }
</style>
